<template>
    <div :class="['hpSiteGallery',openIndex>-1 ? 'galOpened':'']" >
        <div @click="closeGal" class="closebtn"></div>
        
        <a class="navBtn right" @click="showNext"><i class="fal fa-chevron-right pl-s" ></i></a>
        <a class="navBtn left" @click="showPre"><i class="fal fa-chevron-left pl-s" ></i></a>

        <div class="inner">
              <div style="background-image: url('img/cancun/hilton1.jpg')" class="section__item"></div>
              <div style="background-image: url('img/cancun/hilton2.jpg')" class="section__item"></div>
              <div style="background-image: url('img/cancun/hilton3.jpg')" class="section__item"></div>
              <div style="background-image: url('img/cancun/hilton4.jpg')" class="section__item"></div>
        </div>
    </div>
</template>

<style scoped>
  .hpSiteGallery .navBtn{
    position: fixed;z-index: 2000;text-align: center;
    width: 70px;opacity: 1;cursor: pointer;
  }
  .hpSiteGallery .navBtn i{
    font-size: 60px;color:#ffffff;
  }
  .hpSiteGallery .navBtn.right{
    top:50%;right:-20px;transform: translate(-50%,-50%);   
  }
  .hpSiteGallery .navBtn.left{
    top:50%;left:-20px;transform: translate(50%,-50%);text-align: left;  
  }
.galBtn
{
    position: fixed;
    top: 0px;left: 0px;padding: 10px;background-color:red;
    cursor: pointer;
}
  .hpSiteGallery
  {
        position: fixed;
        width: 100vw;height: 100vh;
        top: 0px;left: 0px;
        overflow: hidden;background-color: #fff;
        z-index: 1102;
        display: grid;
        align-items: center;
        text-align: center;
        opacity: 1;
        clip-path: inset(0px 100% 0px 0px);
        transition: all 0.6s cubic-bezier(0.645, 0.045, 0.355, 1.000);
        pointer-events: none;
  }
  .hpSiteGallery.galOpened
  {
      pointer-events: all;
      opacity: 1;
      clip-path: inset(0px 0px 0px 0px);
  }

  .hpSiteGallery .inner
  {
    display: flex;
    gap: 0px;
    max-width: 100vw;
    height: 100%;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding: 80px;
  }
  .hpSiteGallery .inner::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
.section__item
{
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 100vw;
    width: 100vw;
    height: 100vh;
    scroll-snap-align: start;
    scroll-snap-stop: normal;
    font-size: 1.5rem;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;

}

.section__item {
  scroll-snap-align: start;
  width: 100%;
  height: 100%;
}
  .hpSiteGallery .closebtn
  {
    position: absolute;
    top: 2vw;
    right:3vh;
  }


      @media (max-width: 850px) { 
        .hpSiteGallery
        {
            width: 100vw !important;
            height: 100vh !important;
            top: 0px !important;
            left: 0px !important;
        }    
        .hpSiteGallery .inner
        {
            height: 50vh;
            width: 100%;
            padding: 60px 30px;
        }                
        .hpSiteGallery .closebtn
        {
            position: absolute;
            top: 3vh;
            right:3vh;
        }
        .section__item
        {
            background-attachment:initial;
        }
        .hpSiteGallery .navBtn
        {
            display: none;
        }
      }

    @media (max-width: 850px) and (orientation:landscape) {
        .hpSiteGallery .inner
        {
            height: 100vh;
            width: 100%;
            padding: 60px 30px;
        }                 
    }


</style>
<script>
    export default {
        props: {
            openIndex:Number
        },
        watch: { 
            openIndex: function(newVal, oldVal) 
            { 
                if(newVal>-1){
                    
                }            
            }
        },        
        mounted()
        {
        },
        methods:
        {
            showPre()
            {
                let sIndex = this.slideIndex-1;
                if(sIndex<0){sIndex=0;}
                this.navTo(sIndex);
            },
            showNext(){
                let sIndex = this.slideIndex+1;
                if(sIndex>3){sIndex=3;}
                this.navTo(sIndex);
            },
            closeGal(){
                this.$emit("close-gal");
            },
            navTo(index)
            {
                this.slideIndex = index;
                document.getElementsByClassName("section__item")[index].scrollIntoView({ 
                    behavior: 'smooth' 
                });
            },

        },
        data()
        {
            return {
                slideIndex:0,
                isGalOpen:false
            }
        }
    }
</script>  
